export default __webpack_public_path__ + "static/subscribe-on-rss-964b565482fa7c97ce10a4daab13bced.svg";